import styled from "@emotion/styled";

export const LeftNavigationWrapper = styled.div`
  background-color: #1e1e2d;
  height: 100%;
  position: fixed;
  width: 100%;
  max-width: 280px;
  z-index: 999;
  background-size: cover;
  box-shadow: 0px 0px 13px rgb(141, 141, 141);
`;

export const InnerNavigationContainer = styled.div`
  height: 100vh;
  position: relative;
  overflow-y: scroll;
`;

export const LogoContainer = styled.div`
  margin-top: 50px;
`;

export const Navigationlogo = styled.img`
  max-width: 100px;
  margin: 0 auto;
  display: block;
`;

export const NavigationLinksWrapper = styled.div`
  margin-top: 45px;
  padding-left: 5px;
  padding-right: 5px;
`;
